import {
    getRepositoryQueryKey,
    RateGroupsGetAllParameters,
    RateGroupWithPaymentPoliciesResult,
    useRepositoryQuery,
} from '@mews-commander/data-access';

interface RateGroupsGetAllQueryOptions<T> {
    select?: (data: RateGroupWithPaymentPoliciesResult) => T;
    enabled?: boolean;
}

export const getRateGroupsGetAllQueryKey = (params: RateGroupsGetAllParameters) =>
    getRepositoryQueryKey('rateGroups', 'getAll', params);

export const useRateGroupsGetAllQuery = <T = RateGroupWithPaymentPoliciesResult>(
    params: RateGroupsGetAllParameters,
    options: RateGroupsGetAllQueryOptions<T> = {}
) => useRepositoryQuery('rateGroups', 'getAll', params, options);
